$('.mobile-nav-toggle').on('click', function(e) {
    e.preventDefault();
    $('nav').addClass('animate').toggleClass('visible');
    $('html,body').css('overflow', $('nav').hasClass('visible') ? 'hidden' : 'auto');
});



// WEBPACK FOOTER //
// ./scripts/nav.js